export const BASE_TARIFFS_OPTIONS = [
  "position",
  "price",
  "type",
  "createdAt",
  "updatedAt",
  "author",
];
